import fragmentShader from '../shaders/ShaderChunk/arcplane_frontgradient_frag.glsl';
import vertexShader from '../shaders/ShaderChunk/arcplane_frontgradient_vert.glsl';

const THREE = require('three');

class ArcPlaneFrontGradientMaterial extends THREE.ShaderMaterial {
    constructor(parameters) {
        const {
            sizeX, sizeY,
            color0, color1,
            ratio0, ratio1,
            rotate, alphaTest, transparent, opacity
        } = parameters;

        // color0, color1, color2 - colors of any format appropriate for THREE.Color
        // ratio0, ratio1, ratio2 - relative color positions, the order from the less value to the higher one
        // if ratio1 or ratio2 is less then zero then the corresponding color is ignored
        // rotate - linear gradient orientation, 0 is from the bottom to the top, corresponds to css linear-gradient, by degrees
        super({
            uniforms: {
                opacity: { value: 1 },
                viewportWidth: { value: 100 },
                viewportHeight: { value: 100 },
                sizeX: { value: sizeX ?? 100 },
                sizeY: { value: sizeY ?? 100 },
                color0: { value: new THREE.Color(color0 || 0x000000) },
                color1: { value: new THREE.Color(color1 ?? 0xffffff) },
                ratio0: { value: ratio0 || 0 },
                ratio1: { value: ratio1 || 1 },
                rotate: { value: rotate ?? 0 },
                fogColor: { type: 'c', value: new THREE.Color(0x000000) },
                fogNear: { type: 'f', value: 50 },
                fogFar: { type: 'f', value: 80 }
            },
            defines: {
                ALPHA_TEST: alphaTest ?? false
            },
            vertexShader,
            fragmentShader
        });

        this.transparent = transparent;
        this.opacity = opacity ?? 1;
    }

    set viewportWidth(value) {
        this.uniforms.viewportWidth.value = value;
    }

    get viewportWidth() {
        return this.uniforms.viewportWidth.value;
    }

    set viewportHeight(value) {
        this.uniforms.viewportHeight.value = value;
    }

    get viewportHeight() {
        return this.uniforms.viewportHeight.value;
    }

    set opacity(value) {
        if (!this.uniforms) return;
        this.uniforms.opacity.value = value;
    }

    get opacity() {
        if (!this.uniforms) return 1;

        return this.uniforms.opacity.value;
    }

    setGradientUniforms(params) {
        const {
            color0, color1, ratio0, ratio1, rotate
        } = params;

        const { uniforms } = this.uniforms;

        uniforms.color0.value = new THREE.Color(color0 || 0x000000);
        uniforms.color1.value = new THREE.Color(color1 || 0xffffff);

        uniforms.ratio0.value = ratio0 || 0;
        uniforms.ratio1.value = ratio1 || 1;
        uniforms.rotate.value = rotate || 0;
    }
}

export default ArcPlaneFrontGradientMaterial;
